export default {
  ca_es: {
    loadingDimensions: 'Carregant dimensions...',
    noDimensions: 'No hi ha dimensions disponibles',
    noResults: 'No s\'ha trobat cap dimensió',
    searchPlaceholder: 'Cercar dimensió...',
    viewTable: 'Veure taula',
    viewChart: 'Veure gràfic',
    viewMap: 'Veure mapa',
    exportXlsx: 'Exportar XLSX',
    exportPdf: 'Exportar a PDF',
    openConfig: 'Obrir editor de configuració',
    pdfModalTitle: 'Opcions d\'exportació PDF',
    pdfOrientation: 'Orientació',
    pdfPortrait: 'Vertical (Portrait)',
    pdfLandscape: 'Horitzontal (Landscape)',
    pdfQuality: 'Qualitat',
    pdfQualityLow: 'Baixa (més ràpid)',
    pdfQualityMedium: 'Mitjana',
    pdfQualityHigh: 'Alta (més detall)',
    pdfIncludeKpi: 'Incloure KPI widgets',
    pdfHideButtons: 'Amagar botons de taula',
    pdfFitToPage: 'Ajustar a pàgina',
    cancel: 'Cancel·lar',
    export: 'Exportar',
    errorNoBaseUrl: 'URL base no configurada. Introdueix la URL de l\'API al panell de configuració.',
    errorUnauthorized: 'Token no vàlid o caducat (401). Introdueix un bearer vàlid al panell de configuració.'
  },
  es_es: {
    loadingDimensions: 'Cargando dimensiones...',
    noDimensions: 'No hay dimensiones disponibles',
    noResults: 'No se ha encontrado ninguna dimensión',
    searchPlaceholder: 'Buscar dimensión...',
    viewTable: 'Ver tabla',
    viewChart: 'Ver gráfico',
    viewMap: 'Ver mapa',
    exportXlsx: 'Exportar XLSX',
    exportPdf: 'Exportar a PDF',
    openConfig: 'Abrir editor de configuración',
    pdfModalTitle: 'Opciones de exportación PDF',
    pdfOrientation: 'Orientación',
    pdfPortrait: 'Vertical (Portrait)',
    pdfLandscape: 'Horizontal (Landscape)',
    pdfQuality: 'Calidad',
    pdfQualityLow: 'Baja (más rápido)',
    pdfQualityMedium: 'Media',
    pdfQualityHigh: 'Alta (más detalle)',
    pdfIncludeKpi: 'Incluir KPI widgets',
    pdfHideButtons: 'Ocultar botones de tabla',
    pdfFitToPage: 'Ajustar a página',
    cancel: 'Cancelar',
    export: 'Exportar',
    errorNoBaseUrl: 'URL base no configurada. Introduce la URL de la API en el panel de configuración.',
    errorUnauthorized: 'Token no válido o caducado (401). Introduce un bearer válido en el panel de configuración.'
  },
  en_gb: {
    loadingDimensions: 'Loading dimensions...',
    noDimensions: 'No dimensions available',
    noResults: 'No dimensions found',
    searchPlaceholder: 'Search dimension...',
    viewTable: 'View table',
    viewChart: 'View chart',
    viewMap: 'View map',
    exportXlsx: 'Export XLSX',
    exportPdf: 'Export to PDF',
    openConfig: 'Open configuration editor',
    pdfModalTitle: 'PDF export options',
    pdfOrientation: 'Orientation',
    pdfPortrait: 'Portrait (Vertical)',
    pdfLandscape: 'Landscape (Horizontal)',
    pdfQuality: 'Quality',
    pdfQualityLow: 'Low (faster)',
    pdfQualityMedium: 'Medium',
    pdfQualityHigh: 'High (more detail)',
    pdfIncludeKpi: 'Include KPI widgets',
    pdfHideButtons: 'Hide table buttons',
    pdfFitToPage: 'Fit to page',
    cancel: 'Cancel',
    export: 'Export',
    errorNoBaseUrl: 'Base URL not configured. Enter the API URL in the configuration panel.',
    errorUnauthorized: 'Invalid or expired token (401). Enter a valid bearer in the configuration panel.'
  }
}
